import { Heading, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';

const ErrorMessageContent: FC = () => {
  return (
    <>
      <VStack
        mx="auto"
        h="100vh"
        p="2rem"
        flexDirection="column"
        justifyContent="center"
        textAlign="center"
        backgroundColor="#ECF3EE"
      >
        <Heading mb="2rem" as="h1" size="2xl">
          Something went wrong.
        </Heading>
        <Heading mb="2rem" as="h2" size="xl">
          An error has occurred in our application. Please refresh the page and
          try again.{' '}
        </Heading>
        <Text>
          If this error persists, please reach out to customer support at
          support@berrystreet.co
        </Text>
      </VStack>
    </>
  );
};

export default ErrorMessageContent;
